import type { IAssignmentRepository } from '@/core/domain/school/assignment/IAssignmentRepository'
import type { Assignment } from '@/core/domain/school/assignment/Assignment'

/**
 * Use case pour récupérer tous les assignments d'une période scolaire
 */
export class FetchAllAssignmentsUseCase {
  private assignmentRepository: IAssignmentRepository

  constructor(assignmentRepository: IAssignmentRepository) {
    this.assignmentRepository = assignmentRepository
  }

  async execute(schoolId: number, periodId: number): Promise<Assignment[]> {
    return await this.assignmentRepository.fetchAllAssignments(schoolId, periodId)
  }
}
